
<div>
  <button mat-raised-button id="clearBtn" class="btn btn-primary" style="margin-left:10px;" (click)="clearQueue()" [disabled]="isUpdating">Clear Queue</button>
  <button mat-raised-button id="submitBtn" [class]="hasUnsavedChanges ? 'btn btn-success' : 'btn btn-primary'" style="margin-left:10px;" (click)="submitQueue()" [disabled]="isUpdating">Save Changes</button>
</div>
<br />
<div cdkDropList (cdkDropListDropped)="drop($event)">
  <div *ngFor="let item of model.queue" class="drag-drop-list" cdkDrag [cdkDragDisabled]="!item.canBeRemoved">
    <div class="drop-list-details-container">
      <div class="drop-list-details-text">{{item.title}}</div><br />
      <div class="drop-list-details-text-sub">Group of {{item.numberInGroup}}</div>
    </div>
    <div class="drop-list-delete-container">
      <a href="" (click)="removeItem($event, item.title, item.canBeRemoved)" [class]="item.canBeRemoved ? 'drop-list-details-anchor' : 'drop-list-details-anchor-disabled'">X</a>
    </div>
  </div>
</div>

